<template>
  <a-modal
      :title="titleShow"
      :visible="visible"
      :maskClosable="false"
      :width="960"
      destroyOnClose
      @ok="onSaveComment"
      @cancel="() => this.visible = false"
      :confirmLoading="loading">
    <a-form :form="form">
      <a-form-item label='意见内容' v-bind="formItemLayout">
        <a-textarea
            placeholder="请填写意见"
            :rows="4"
            v-decorator="['content', {initialValue:trip.content, rules: [{ required: true, message: '请填写意见' }]}]"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'HandleCommentModel',
  components: {},
  data () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      trip: {
        content: '同意'
      },
      titleShow: '审批意见',
      formItemLayout: {
        labelCol: {
          md: { span: 5 }
        },
        wrapperCol: {
          md: { span: 12 }
        }
      }
    }
  },
  methods: {
    onStartLoadData (val) {
      this.visible = true
      this.titleShow = '审批意见'
      this.trip = {}
      this.trip.content = '已阅！'
      if (val === '0') {
        this.titleShow = '退回意见'
        this.trip.content = '请修改后重报！'
      }
      this.trip.type = val
    },
    onSaveComment () {
      let that = this
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        let params = this.form.getFieldsValue()
        params.content = params.content.trim()
        if (Object.keys(params.content).length === 0) {
          this.$message.error('所填的意见内容不可为空！')
          return
        }

        params.type = this.trip.type
        that.visible = false
        that.$emit('success', params)
      })
    }
  }
}
</script>

<style scoped>

</style>
